import {IEnvironment} from "../../models/environment";
import {api} from "../../config/axios";
import IResponseBody from "../../interfaces/response-body";
import {environments} from "../../config/environments";
import IEnvironmentStatus from "../../interfaces/environment-status";


async function getDashboardRoutines(
  environment: IEnvironment,
  initialDate: Date | null,
  finalDate: Date | null
): Promise<IEnvironmentStatus | undefined> {
  const response = await api.get<IResponseBody<IEnvironmentStatus>>(
    environments.url_dashboard + `/retroativo/status/${environment.id}`, {
      params: {
        dataInicial: convertDate(initialDate),
        dataFinal: convertDate(finalDate)
      }
    }
  );

  return response.data.data;
}

  function convertDate(date: Date | null) {
    return date?.toLocaleDateString("pt-BR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).split("/").reverse().join("-");
  }
  export default{getDashboardRoutines};
